import { graphql } from "@/lib/gql/__generated__";

export const EcReceiptItem_ManagementECPage_Query = graphql(`
	query EcReceiptItem_ManagementECPage($hotelID: ID!, $receiptID: ID!) {
		ecReceiptItem(hotelID: $hotelID, receiptID: $receiptID) {
			id
			hotelID
			receiptID
			guestName
			guestNameKana
			guestEmail
			guestTel
			guestPostalCode
			guestAddress
			purchasedDate
			totalGuestCharge
			purchasedItems {
				name
				amount
				eachPrice
			}
		}
	}
`);
